import React from "react";
import ReactDOM from "react-dom/client";
import Settings from "./components/Settings";
import { HashRouter, Routes, Route } from "react-router-dom";
import SingleVideos from "./components/SingleVideos";
import "./index.css";
import GeneralSettings from "./components/Settings/GeneralSettings";
import FeedsSettings from "./components/Settings/FeedsSettings";
import TranslationSettings from "./components/Settings/TranslationSettings";
import AdvancedSettings from "./components/Settings/AdvancedSettings";
import SingleVideosSettings from "./components/Settings/SingleVideosSettings";
import AboutUs from "./components/About";
import Support from "./components/Support";
import { Provider } from "react-redux";
import store from "./store";
import NotificationCenter from "./components/NotificationCenter";

const root = ReactDOM.createRoot(document.getElementById("sby-settings"));
const urlSearchParams = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());

root.render(
  <Provider store={store}>
    <React.StrictMode>
      <HashRouter>
        <Routes>
          {params.page === "youtube-feed-settings" && (
            <Route path="/" element={<Settings />}>
              <Route path={"/"} element={<GeneralSettings />} />
              <Route path={"/feeds"} element={<FeedsSettings />} />
              <Route path={"/translation"} element={<TranslationSettings />} />
              <Route path={"/advanced"} element={<AdvancedSettings />} />
              <Route
                path={"/single-videos"}
                element={<SingleVideosSettings />}
              />
            </Route>
          )}
          {params.page === "youtube-feed-single-videos" && (
            <Route path="/" element={<SingleVideos />} />
          )}
          {params.page === "youtube-feed-about" && (
            <Route path="/" element={<AboutUs />} />
          )}
          {params.page === "youtube-feed-support" && (
            <Route path={"/"} element={<Support />} />
          )}
        </Routes>
        <NotificationCenter />
      </HashRouter>
    </React.StrictMode>
  </Provider>
);
